import {SuggestionStates, type Suggestion, type SuggestionState} from '../../../conversation-types'
import {
  AutomatedReviewSuggestionApplied,
  AutomatedReviewSuggestionError,
  AutomatedReviewSuggestionPending,
  AutomatedReviewSuggestionPresent,
} from './AutomatedReviewSuggestionStates'

export interface AutomatedReviewSuggestionProps {
  applySuggestionPath?: string
  commentAuthorLogin?: string
  automatedCommentId: string
  commentTitle?: string
  suggestion?: Suggestion
  suggestionState?: SuggestionState
}

const SuggestionStateComponents = {
  [SuggestionStates.Pending]: AutomatedReviewSuggestionPending,
  [SuggestionStates.Error]: AutomatedReviewSuggestionError,
  [SuggestionStates.Applied]: AutomatedReviewSuggestionApplied,
  [SuggestionStates.Present]: AutomatedReviewSuggestionPresent, // Default suggestion component
} as const

export function AutomatedReviewSuggestion({
  applySuggestionPath,
  commentAuthorLogin,
  automatedCommentId,
  commentTitle,
  suggestion,
  suggestionState,
}: AutomatedReviewSuggestionProps) {
  if (!suggestionState || suggestionState === SuggestionStates.NoSuggestion) {
    return null
  }

  const SuggestionComponent = SuggestionStateComponents[suggestionState]

  if (!SuggestionComponent) {
    return null
  }

  return (
    <SuggestionComponent
      suggestion={suggestion}
      automatedCommentId={automatedCommentId}
      commentTitle={commentTitle}
      commentAuthorLogin={commentAuthorLogin}
      applySuggestionPath={applySuggestionPath}
    />
  )
}

try{ AutomatedReviewSuggestion.displayName ||= 'AutomatedReviewSuggestion' } catch {}